import { useIsFetching } from '@tanstack/react-query';
import {
  useActiveProjectCohortId,
  useActiveProjectId,
} from '../../../../../hooks';

export const useIsFetchingMedicalResults = (patientId: string) => {
  const projectId = useActiveProjectId();
  const cohortId = useActiveProjectCohortId();

  const medicalResultQueriesFetching = useIsFetching({
    queryKey: [
      'medical-results',
      'v3',
      patientId,
      'results',
      {
        projectId,
        cohortId,
      },
    ],
    fetchStatus: 'fetching',
    predicate: query => {
      // Exclude memberUpload, unmappedLabs, and documentExtractionV2 source
      // queries from blocking the UI. Allow other sections to display while
      // wearables/uncategorized/extracted data is loading or retrying, so one
      // failing source can never hold the whole page on the loader.
      const queryKey = query.queryKey;
      const source = queryKey[queryKey.length - 1];
      return (
        source !== 'memberUpload' &&
        source !== 'unmappedLabs' &&
        source !== 'documentExtractionV2'
      );
    },
  });

  return medicalResultQueriesFetching > 0;
};
